import Vue from 'vue'

let _bus

const newBus = new Vue()

if (window.__ERP_PUBLIC_SHARED_BUS__) {
  _bus = window.__ERP_PUBLIC_SHARED_BUS__
} else {
  window.__ERP_PUBLIC_SHARED_BUS__ = _bus = newBus
}

export default _bus



// WEBPACK FOOTER //
// ./src/public/utils/bus.js